import { z } from 'zod';

export const OrderlessDisclaimerTaskSchema = z.object({
  acknowledged: z
    .boolean()
    .refine((v) => v, 'You must acknowledge the disclaimer to continue'),
});

export type OrderlessDisclaimerData = {
  orderlessDisclaimer: z.infer<typeof OrderlessDisclaimerTaskSchema>;
};
